export function ConfigError({ title, detail }: { title: string; detail: string }) {
  return (
    <div className="mx-auto mt-16 max-w-lg px-4">
      <div className="gsl-panel p-6" role="alert">
        <p className="gsl-display text-2xl">{title}</p>
        <p className="mt-3 text-sm text-muted-foreground">{detail}</p>
      </div>
    </div>
  );
}
